import { render, staticRenderFns } from "./videoPaySuccess.vue?vue&type=template&id=e4622248&scoped=true&"
import script from "./videoPaySuccess.ts?vue&type=script&lang=js&"
export * from "./videoPaySuccess.ts?vue&type=script&lang=js&"
import style0 from "./videoPaySuccess.less?vue&type=style&index=0&id=e4622248&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4622248",
  null
  
)

export default component.exports